export enum ROUTES {
    LOGIN_ROUTE = '/login',
    MAIN_ROUTE = '/',
    ACCOUNT_ROUTE = '/account',
    SETTINGS_ROUTE = '/settings',
    CHANGE_PASSWORD_ROUTE = '/change-password',
    TRANSACTIONS_ROUTE = '/transactions',
    TRANSACTION_ROUTE = '/transaction/:id',
    PROFILE_ROUTE = '/profile/:id',
    CHATS_ROUTE = '/chats',
    ADD_BALANCE_RUB_ROUTE = '/balance',
    SEND_MONEYS_SITE_ROUTE = '/send-moneys',
    WITHDRAWAL_RUB_ROUTE = '/withdrawal',
    RESET_PASSWORD_ROUTE = '/reset-password',
    RESET_PASSWORD_FINAL_ROUTE = '/reset-password-finish/:id',
    FIN_ANALITYCS_ROUTE = '/fin-analitycs',
    ADMIN_ROUTE = '/admin',
    CREATE_POST_ROUTE = '/admin/create-poster',
    ACTION_POST_ROUTE = '/admin/poster-actions',
    POSTERS_ADMIN_ROUTE = '/admin/posters',
    POSTER_ROUTE = '/poster/:id',
    UPLOADED_DOCUMENTS_ROUTE = '/admin/uploaded-documents',
    UPLOADED_DOCUMENT_ROUTE = '/uploaded-document',
    SUBJECT_RIGHTS_ROUTE = '/admin/subject-rights',
    SUBJECT_RIGHTS_ACTIONS_ROUTE = '/admin/subject-rights-actions',
    COMPOUND_SUBJECT_RIGHTS_ACTIONS_ROUTE = '/admin/compound-subject-rights-actions',
    BILL_FILL_ROUTE = '/bill-fill',
    ADMIN_ALL_BILLS_ROUTE = '/admin/all-bills',
    PROGRAMMS_MINFIN_ROUTE = '/admin/programms-minfin'

}


export enum AUTHED_ROUTES {
    ACCOUNT_ROUTE = '/account',
    SETTINGS_ROUTE = '/settings',
    TRANSACTIONS_ROUTE = '/transactions',
    TRANSACTION_ROUTE = '/transaction/:id',
    PROFILE_ROUTE = '/profile/:id',
    CHATS_ROUTE = '/chats',
    ADD_BALANCE_RUB_ROUTE = '/balance',
    SEND_MONEYS_SITE_ROUTE = '/send-moneys',
    WITHDRAWAL_RUB_ROUTE = '/withdrawal',
    ADMIN_ROUTE = '/admin',
    CREATE_POST_ROUTE = '/admin/create-poster',
    ACTION_POST_ROUTE = '/admin/poster-actions',
    UPLOADED_DOCUMENTS_ROUTE = '/admin/uploaded-documents',
    SUBJECT_RIGHTS = '/admin/subject-rights',
    SUBJECT_RIGHTS_ACTIONS = '/admin/subject-rights-actions',
    COMPOUND_SUBJECT_RIGHTS_ACTIONS = '/admin/compound-subject-rights-actions',
    UPLOADED_DOCUMENT_ROUTE = '/uploaded-document/:id',
    BILL_FILL = '/bill-fill',
    ADMIN_ALL_BILLS = '/admin/all-bills',
    REGISTRY_ROUTE = '/registry',
    FIN_ANALITYCS_ROUTE = '/fin-analitycs',
    PROGRAMMS_MINFIN_ROUTE = '/admin/programms-minfin'
}

export enum PUBLIC_ROUTES {
    LOGIN_ROUTE = '/login',
    MAIN_ROUTE = '/',
    RESET_PASSWORD_ROUTE = '/reset-password',
    RESET_PASSWORD_FINAL_ROUTE = '/reset-password-finish/:id',
    POSTER_ROUTE = '/poster/:id',
    IMPORTANT_ROUTE = '/important',
    VACANCY_ROUTE = '/vacancy',
    CURRENCIES_ROUTE = '/currencies'
}



export type GLOBAL_ROUTES = AUTHED_ROUTES | PUBLIC_ROUTES